import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'

Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/terms',
            name: 'Terms and Conditions',
            component: Terms
        },
        {
            path:'/privacy',
            name: 'Privacy Policy',
            component: Privacy
        },
        {
            path: '/download/ios',
            beforeEnter(to, from, next) {
                console.log("Redirecting to Apple");
                window.location = "https://itunes.apple.com/us/app/livio-music/id1251992029?mt=8"
            }
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }else if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js